<template>
  <div>
    <Dialog v-if="state.visible" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common">
      <div class="dialog" :class="cssType">
        <div class="dialog-title">
          {{ $t('cny.record') }}
        </div>
        <div class="dialog-content">
          <div class="record-table">
            <div class="thead">
              <div class="tr">
                <div class="th reach-node">
                  {{ $t('cny.rewards.reachNode') }}
                </div>
                <div class="th details">
                  {{ $t('accum.recordDialog.details') }}
                </div>
                <div class="th time">
                  {{ $t('accum.recordDialog.time') }}
                </div>
              </div>
            </div>
            <div class="tbody">
              <div class="tr" v-for="item in state.data.list" :key="item.id">
                <div class="td reach-node">
                  {{ $t('cny.rewards.lotteryNTimes', { times: item.lotteryTimes }) }}
                </div>
                <div class="td details">
                  <div class="details-item" v-for="(prop, index) in item.props" :key="index">
                    {{ $t(`props.${prop.id}`) }} * {{ prop.count }}
                  </div>
                </div>
                <div class="td time">
                  {{ dayjs(item.time).format('YYYY-MM-DD HH:mm:ss') }}
                </div>
              </div>
            </div>
            <div class="empty-data" v-if="state.data.list.length === 0">
              {{ $t('payment.noData') }}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, reactive, nextTick, computed } from 'vue'
import { isMobile } from '@/utils'
import Dialog from '@/components/Dialog/ActCny/index.vue'
import dayjs from 'dayjs'
const cssType = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => {}
  },
  cb: {
    type: Function,
    default: () => {}
  }
})

const state = reactive({
  visible: false,
  data: computed(() => {
    const data = JSON.parse(JSON.stringify(props.data))
    data.list.sort((a, b) => b.time - a.time)
    return data
  })
})

watch(() => props.modelValue, (newVal) => {
  nextTick(() => {
    state.visible = newVal
  })
}, {
  immediate: true
})

const emit = defineEmits(['update:modelValue'])

const updateModelValue = (value) => {
  emit('update:modelValue', value)
  props.cb && props.cb(value)
}



</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
